import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import * as s from './HorizontalScrollSection.module.scss'
import DashboardCard from '../DashboardBlock/DashboardCard'

interface Props {
  slideWidth?: number
  slideGap?: number
  totalCards?: number
}

const HorizontalScrollSection: React.FC<Props> = ({
  slideGap = 7,
  totalCards = 10,
}) => {
  const sectionRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const [translateX, setTranslateX] = useState(0)
  const firstCardRef = useRef<HTMLDivElement>(null)
  const [slideWidth, setSlideWidth] = useState(0)

  useLayoutEffect(() => {
    if (firstCardRef.current) {
      const width = firstCardRef.current.offsetWidth
      setSlideWidth(width)
    }
  }, [])
  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current
      const content = contentRef.current
      if (!section || !content) return

      const sectionRect = section.getBoundingClientRect()
      const viewportHeight = window.innerHeight

      const start = viewportHeight - sectionRect.bottom
      const end = viewportHeight - sectionRect.height - 80

      const scrollProgress = Math.max(0, Math.min(1, start / end))

      const totalSlideWidth = totalCards * (slideWidth + slideGap) - slideGap

      setTranslateX(-scrollProgress * (totalSlideWidth - window.innerWidth))
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [totalCards, slideWidth, slideGap])

  return (
    <section ref={sectionRef} className={s.scrollTrack}>
      <div className={s.sliderWrapper}>
        <div
          ref={contentRef}
          className={s.sliderContent}
          style={{
            transform: `translateX(${translateX}px)`,
          }}
        >
          {Array.from({ length: totalCards }, (_, idx) => (
            <div
              key={idx}
              className={s.card}
              ref={idx === 0 ? firstCardRef : null}
              style={{ marginRight: `${slideGap}px` }}
            >
              <DashboardCard imageIdx={idx} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HorizontalScrollSection
